import { Notification } from '@vds/notifications';
import { Body, Title } from '@vds/typography';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { isTab,isMdot,isNative } from '../utils/globalConfig';
import { convertStringToElements } from '@vds/html-parsers';
import {dispatchNotifyEvent} from '../utils/tagging'



const MainDiv = styled.div`
margin-left: 2%;
margin-bottom: 16px;
display: flex;
width: ${isTab ? '290px' : '348px'};
height:${isMdot || isNative ? '162px' : '200px'};
padding: 16px 24px;
flex-direction: column;
align-items: flex-start;
gap: 16px;
border-radius: 16px;
border: ${props => props.border || '1px solid var(--vds-elements-text-icons-borders-secondary-ondark, #A7A7A7)'};

`

const StyledDisplayFlexDiv = styled.div`
display: flex;
gap: 16px;
`

const StyledImageDevice = styled.img`
height: 50px;
`;

export default function AdvisoryDetails({ deviceDetailInfo,travelReadynotification}) {

    useEffect(() => {
        if (!deviceDetailInfo?.travelReady) {
            dispatchNotifyEvent(travelReadynotification?.header, '', convertStringToElements(travelReadynotification?.text))
        }
    }, [])

    return (
        <React.Fragment>
            {/* device information */}
            {deviceDetailInfo && !deviceDetailInfo.travelReady && 
                <MainDiv>

                    {!deviceDetailInfo?.travelReady &&
                        <Notification
                            type={travelReadynotification?.type}
                            title={travelReadynotification?.header}
                            subtitle={convertStringToElements(travelReadynotification?.text)}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                        />}
                    <StyledDisplayFlexDiv>
                        <StyledImageDevice alt={deviceDetailInfo?.deviceImageAlt} src={deviceDetailInfo?.deviceImageUrl}></StyledImageDevice>
                        
                        <div>
                            <Title size="small" bold>{deviceDetailInfo?.deviceNickName}</Title>
                            <Body size="large">{deviceDetailInfo?.formattedMtn}</Body>
                        </div>
                    </StyledDisplayFlexDiv>
                </MainDiv>}
        </React.Fragment>
        
    )

    

}